var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{attrs:{"href":_vm.link,"target":_vm.target,"type":"info","underline":false}},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }